import { render, staticRenderFns } from "./SimpleLoginPhone.vue?vue&type=template&id=3117e7d3&scoped=true&"
import script from "./SimpleLoginPhone.vue?vue&type=script&lang=js&"
export * from "./SimpleLoginPhone.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLoginPhone.vue?vue&type=style&index=0&id=3117e7d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3117e7d3",
  null
  
)

export default component.exports